import { z } from 'zod'

export const ComboOfferItemSchema = z.object({
  productId: z.string().min(1),
  variantId: z.string().optional().nullable(),
  productName: z.string().optional(),
  productSku: z.string().optional(),
  variantSku: z.string().optional(),
  variantDescription: z.string().optional(),
  basePrice: z.number().optional(),
  quantity: z.number().int().min(1).max(99),
})

export const ComboOfferSchema = z.object({
  id: z.string(),
  name: z.string(),
  description: z.string().nullable(),
  sku: z.string(),
  price: z.number().min(0),
  stockQty: z.number().int().min(0),
  lowStockThreshold: z.number().int().min(0),
  isActive: z.boolean(),
  items: z.array(ComboOfferItemSchema),
  createdAt: z.string(),
  updatedAt: z.string(),
})

export const CreateComboInput = z.object({
  name: z.string().min(1, 'Name is required').max(200).trim(),
  description: z.string().max(2000).trim().optional(),
  price: z.number().min(0, 'Price must be non-negative'),
  stockQty: z.number().int().min(0).default(0),
  lowStockThreshold: z.number().int().min(0).default(5),
  isActive: z.boolean().default(true),
  sku: z.string().max(50).trim().toUpperCase().optional(),
  items: z.array(z.object({
    productId: z.string().min(1),
    variantId: z.string().optional().nullable(),
    quantity: z.number().int().min(1).max(99).default(1),
  })).min(2, 'A combo needs at least two items'),
})

export const UpdateComboInput = CreateComboInput.partial()

export type ComboOffer = z.infer<typeof ComboOfferSchema>
export type CreateComboInput = z.infer<typeof CreateComboInput>
export type UpdateComboInput = z.infer<typeof UpdateComboInput>
